// Queries
import isAuthenticated from './queries/IsAuthenticated.gql';
import getMe from './queries/GetMe.gql';

import getProduct from './queries/GetProduct.gql';
import getProducts from './queries/GetProducts.gql';
import getProductCategories from './queries/GetProductCategories.gql';
import getProductMessage from './queries/GetProductMessage.gql';

// Mutations
import getAccessToken from './mutations/GetAccessToken.gql';

import addContactForm from './mutations/AddContactForm.gql';

export const Query = {
  isAuthenticated,
  getMe,
  getProduct,
  getProducts,
  getProductCategories,
  getProductMessage,
};
export const Mutation = {
  getAccessToken,
  addContactForm,
};
